import { ToggleSwitch } from '@appd/uik';

type ToggleSwitchWithTitleProps = {
  title: string;
} & ToggleSwitch.Props;

export const ToggleSwitchWithTitle = ({ title, ...toggleSwitchProps }: ToggleSwitchWithTitleProps): JSX.Element => {
  return (
    <div className="flex flex-row items-center justify-between mr-[40px]">
      <div className="text-sm font-semibold text-default-text leading-5">{title}</div>
      <ToggleSwitch {...toggleSwitchProps} />
    </div>
  );
};
